import React from 'react'

function FeatureGate({ enabled, children, dimOnly, onDisabledClick }) {
    if (enabled) return children
    
    const child = React.Children.only(children)
    const disabledStyle = {
        ...(child.props.style || {}),
        opacity: 0.45,
    }
    
    // Only apply pointer-events: none if we DON'T have an onDisabledClick handler
    if (!onDisabledClick) {
        disabledStyle.pointerEvents = 'none'
    }
    
    // Apply grayscale unless dimOnly is true
    if (!dimOnly) disabledStyle.filter = 'grayscale(100%)'
    
    return React.cloneElement(child, {
        onClick: onDisabledClick ? (e) => {
            // Stop event bubbling and trigger our toast
            e.preventDefault()
            e.stopPropagation()
            onDisabledClick()
        } : undefined,
        'aria-disabled': true,
        style: disabledStyle,
    })
}

export default FeatureGate